// extracted by mini-css-extract-plugin
export default {"iconWrapper":"iconWrapper__tlPgd"};